import { render, staticRenderFns } from "./SlrcPL_List.vue?vue&type=template&id=6d079a16"
import script from "./SlrcPL_List.vue?vue&type=script&lang=js"
export * from "./SlrcPL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports